import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getValidClientAccessToken } from '../auth/clientSession';
export default function ClientProtectedRoute() {
  const [state, setState] = useState('checking');
  useEffect(() => {
    let active = true;
    getValidClientAccessToken().then(token => { if (active) setState(token ? 'ready' : 'login'); }).catch(() => { if (active) setState('offline'); });
    const expired = () => setState('login');
    window.addEventListener('client-session-expired', expired);
    return () => { active = false; window.removeEventListener('client-session-expired', expired); };
  }, []);
  if (state === 'login') return <Navigate to="/client/login" replace />;
  if (state === 'offline') return <div className="p-8 text-center">We couldn’t verify your session. Reconnect and <button type="button" className="text-indigo-700 underline" onClick={() => window.location.reload()}>try again</button>.</div>;
  if (state === 'checking') return <div className="p-8 text-center">Opening your portal…</div>;
  return <Outlet />;
}
